import { createAction, createReducer } from 'redux-act';
import Immutable from 'seamless-immutable';
import moment from 'moment';

const INITIAL_STATE = Immutable({
  orders: [],
  // durationInMinutes: moment.duration(1, 'day').asMinutes(),
  selectedMode: 'day',
  ordersStartDate: moment().startOf('day').toDate(),
  ordersEndDate: moment().endOf('day').toDate(),
  lastUpdate: new Date(),
  loading: false,
  orderSearchValue: null,
  selectedOrder: null,
  selectedOrderForDeliveryInfo: null,
});

export const loadOrders = createAction('LOADORDERS');
export const loadOrdersSucceeded = createAction('LOADORDERSSUCCEEDED');
export const loadOrdersFailed = createAction('LOADORDERSFAILED');

export const loadOrder = createAction('LOADORDER');
export const loadOrderSucceeded = createAction('LOADORDERSUCCEEDED');
export const loadOrderFailed = createAction('LOADORDERFAILED');

export const orderUpdatedOnServer = createAction('ORDERUPDATEDONSERVER');
export const setMode = createAction('SETMODE');

export const proceedOrder = createAction('PROCEEDORDER');
export const declineOrder = createAction('DECLINEORDER');
export const selectOrder = createAction('SELECTORDER');
export const selectOrderForDeliveryInfo = createAction('SELECTORDER_DELIVERY');

export const removeObsoleteOrders = createAction('REMOVEOBSOLETEORDERS');
export const updateOrderView = createAction('UPDATEORDERVIEW');

export const setOrderSearchValue = createAction('SETORDERSEARCHVALUE');


const mapOrder = o => ({
  id: o.orderId,
  pickupName: o.pickupName,
  pickupCode: o.pickupNumber,
  pickupTime: o.preOrderTime ? moment.utc(o.preOrderTime).local().format('HH:mm') : o.preOrderTime,
  pickupTimeIsSet: o.preOrderTime ? moment(o.preOrderTime).hours() > 0 : false,
  pickupTimeNumeric: o.preOrderTime ? moment.utc(o.preOrderTime).valueOf() : moment.utc(o.dateTime).valueOf(),
  proceedText: o.proceedTextInWaiterUi,
  color: o.proceedColorInWaiterUi,
  show: o.show,
  note: o.note,
  userNote: o.userNote,
  canReject: o.canReject,
  loading: false,
  guid: o.guid,
  address: o.address,
  telephone: o.telephone,
  isDelivery: !!o.address,
  articles: o.entries.map(e => ({
    name: e.productName,
    quantity: e.amount,
    note: e.note,
    features: [
      ...e.features.map(f => f.value),
      ...e.productVariants.map(p => p.values.map(v => v.variantValue)).reduce((a, b) => a.concat(b), []),
    ],
  })),
});

const setOrderToLoadingState = (state, orderId) => {
  const indexOfOrder = state.orders.findIndex(o => o.id === orderId);
  if (indexOfOrder !== -1) {
    return state.setIn(['orders', indexOfOrder, 'loading'], true);
  }
  return state;
};

const reducers = createReducer({
  [loadOrders]: state => state.merge({ loading: true }),
  [loadOrder]: (state, orderId) => setOrderToLoadingState(state, orderId),
  [proceedOrder]: (state, orderId) => setOrderToLoadingState(state, orderId),
  [declineOrder]: (state, orderId) => setOrderToLoadingState(state, orderId),
  [loadOrdersSucceeded]: (state, { orders }) => {
    const newOrders = orders.map(mapOrder);
    return state.merge({ orders: newOrders, loading: false });
  },
  [loadOrderFailed]: (state, orderId) => {
    const indexOfOrder = state.orders.findIndex(o => o.id === orderId);
    return state.setIn(['orders', indexOfOrder, 'loading'], false);
  },
  [loadOrderSucceeded]: (state, { order }) => {
    const indexOfOrder = state.orders.findIndex(o => o.id === order.orderId);
    const newOrder = mapOrder(order);

    if (indexOfOrder === -1 && newOrder.show) {
      const orders = state.orders.asMutable();
      let i;
      for (i = 0; i < orders.length; i++) {
        if (orders[i].pickupTimeNumeric > newOrder.pickupTimeNumeric) {
          break;
        }
      }

      orders.splice(i, 0, newOrder);
      return state.merge({ orders });
    } else if (indexOfOrder !== -1 && !newOrder.show) {
      return state.setIn(['orders', indexOfOrder, 'show'], false);
    }

    return state.setIn(['orders', indexOfOrder], newOrder);
  },
  [removeObsoleteOrders]: (state) => {
    const orders = state.orders.asMutable();
    const obsoleteOrders = orders.filter(o => !o.show);
    for (let i = 0; i < obsoleteOrders.length; i++) {
      const indexOfOrder = orders.findIndex(o => o.id === obsoleteOrders[i].id);
      orders.splice(indexOfOrder, 1);
    }

    return state.merge({ orders });
  },
  [loadOrdersFailed]: state => state.merge({ loading: false }),
  [setMode]: (state, { mode, start, end, slide }) => state.merge({
    selectedMode: mode,
    ordersStartDate: start != null ? start : moment().add('year', -1).toDate(),
    ordersEndDate: end,
    relativeDurationMilliseconds: moment.duration(moment(end).diff(moment())).asMilliseconds(),
    slidingWindowModeEnabled: slide,
  }),
  [updateOrderView]: state => state.merge({
    lastUpdate: new Date(),
    ordersEndDate: state.slidingWindowModeEnabled && state.relativeDurationMilliseconds
      ? moment.min(moment().add('milliseconds', state.relativeDurationMilliseconds), moment().endOf('day')).toDate()
      : state.ordersEndDate,
  }),
  [setOrderSearchValue]: (state, orderSearchValue) => state.merge({ orderSearchValue }),
  [selectOrder]: (state, selectedOrder) => state.merge({ selectedOrder }),
  [selectOrderForDeliveryInfo]: (state, selectedOrderForDeliveryInfo) => state.merge({ selectedOrderForDeliveryInfo }),
}, INITIAL_STATE);

export default reducers;
